export default __webpack_public_path__ + "static/media/risks.779a8af1.png";